import { Fragment, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useOpenCashRegisterMutation } from '../../../redux/api/marktApi';
import { toast } from 'react-toastify';
import { useApiErrorToast } from '../../../hooks/useApiError';

const OpenCashRegister = ({ cashRegister }) => {
  const [showModal, setShowModal] = useState(false);
  const [doOpenCashRegister, { isLoading }] = useOpenCashRegisterMutation();
  const apiErrorToast = useApiErrorToast();

  const handleSubmit = async () => {
    if (!cashRegister?.id) {
      toast.error('Fehler - Kassen ID nicht gefunden!');
      return;
    }
    try {
      const result = await doOpenCashRegister(cashRegister.id).unwrap();
      // result === { id, balance, open, session_id }
      if (result.open) {
        toast.success(`Kasse geöffnet! Sitzung: ${result.session_id}`);
      } else {
        toast.warning('Kasse konnte nicht geöffnet werden.');
      }
    } catch (err) {
      apiErrorToast(err, 'Unbekannter Fehler');
    } finally {
      setShowModal(false);
    }
  };

  return (
    <Fragment>
      <Button
        className='btn btn-primary ms-2'
        onClick={() => setShowModal(true)}
        disabled={cashRegister.open}
      >
        Kasse öffnen
      </Button>
      <Modal show={showModal}>
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title>Kasse öffnen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{`Möchtest Du die Kasse ${cashRegister.name} wirklich öffnen?`}</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowModal(false)}>
            abbrechen
          </Button>
          <Button variant='success' onClick={handleSubmit} disabled={isLoading}>
            Kasse öffnen
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default OpenCashRegister;
